import { SortDescriptor } from "@progress/kendo-data-query";

/**
 * Egy Kendo grid elnevezett elrendezése (rmgenuser_setting, type = GridLayout).
 * A layout JSON-ként kerül a user_setting oszlopba.
 */
export default interface GridLayoutProfile {
  profileName: string;
  isDefault: boolean;
  layout: GridLayout;
}

export interface GridLayout {
  /** Oszlop kulcsok (field) a megjelenítés sorrendjében. */
  columnOrder: string[];
  /** Elrejtett oszlopok kulcsai. */
  hiddenColumns: string[];
  /** A felhasználó által átméretezett oszlopok szélessége px-ben (field kulcs). */
  columnWidths: Record<string, number>;
  sort: SortDescriptor[];
  /**
   * A szűrősor állapota, a gridtől függő alakban (JSON-ba írható). A GridLayoutSettings nem értelmezi,
   * csak a `getFilter` / `setFilter` kezelők között adja át; azok ellenőrzik a saját alakjukat.
   */
  filter?: unknown;
}

export const emptyGridLayout: GridLayout = {
  columnOrder: [],
  hiddenColumns: [],
  columnWidths: {},
  sort: [],
};
